<template>
	<div class="lsv-page-standalone">
		<LSVCompactNew />
	</div>
</template>

<script>
	import LSVCompactNew from '../components/page_components/lsv/LSVCompactNew.vue'
	import { useLabelsStore } from '@/stores/labels'

	export default {
		name: "LSV",
		components: {
			LSVCompactNew
		},
		mounted() {
			document.body.style.margin = '0';
			document.body.style.padding = '0';
			document.documentElement.style.margin = '0';
			document.documentElement.style.padding = '0';
			const labelsStore = useLabelsStore();
			document.title = labelsStore.labels.vsl_page_title || 'NQA · Descover How to multiply your sales by 10';
		},
		beforeUnmount() {
			document.body.style.margin = '';
			document.body.style.padding = '';
			document.documentElement.style.margin = '';
			document.documentElement.style.padding = '';
		}
	};
</script>

<style scoped>
	.lsv-page-standalone {
		min-height: 100vh;
		margin: 0;
		padding: 0;
	}
</style>
